"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zVoidPaymentRequest = exports.zRecordPaymentRequest = exports.zPaymentMethod = exports.PAYMENT_METHODS = void 0;
const zod_1 = require("zod");
const money_js_1 = require("./money.js");
exports.PAYMENT_METHODS = ["cash", "check", "credit_card", "debit_card", "ach", "financing", "insurance", "other"];
exports.zPaymentMethod = zod_1.z.enum(exports.PAYMENT_METHODS);
exports.zRecordPaymentRequest = zod_1.z.object({
    // Nonzero, matching the DB's own payments_amount_nonzero_check — a
    // NEGATIVE amount is deliberately allowed (a refund), not just accepted
    // by omission; zMoney's format already requires exactly 2dp.
    amount: money_js_1.zMoney.refine((v) => v !== "0.00", { message: "amount must not be zero" }),
    method: exports.zPaymentMethod,
    reference: zod_1.z.string().trim().min(1).nullable().optional(),
    receivedOn: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD"),
    notes: zod_1.z.string().trim().min(1).nullable().optional(),
});
exports.zVoidPaymentRequest = zod_1.z.object({ reason: zod_1.z.string().trim().min(1) });
//# sourceMappingURL=payments.js.map